/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Err_Parent_LevelInputs */

const en_sch_err_parent_level = /** @type {(inputs: Sch_Err_Parent_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allowed parents need a higher level than this type, and types that list this one as a parent need a lower level.`)
};

const de_sch_err_parent_level = /** @type {(inputs: Sch_Err_Parent_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erlaubte übergeordnete Typen brauchen eine höhere Ebene als dieser Typ, und Typen, die diesen als übergeordneten Typ erlauben, brauchen eine niedrigere.`)
};

/**
* | output |
* | --- |
* | "Allowed parents need a higher level than this type, and types that list this one as a parent need a lower level." |
*
* @param {Sch_Err_Parent_LevelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_err_parent_level = /** @type {((inputs?: Sch_Err_Parent_LevelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Err_Parent_LevelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_err_parent_level(inputs)
	return en_sch_err_parent_level(inputs)
});